import { render, staticRenderFns } from "./BasketSummary.vue?vue&type=template&id=d06d03d8&scoped=true"
import script from "./BasketSummary.vue?vue&type=script&lang=js"
export * from "./BasketSummary.vue?vue&type=script&lang=js"
import style0 from "./BasketSummary.vue?vue&type=style&index=0&id=d06d03d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06d03d8",
  null
  
)

export default component.exports